module.exports = __webpack_public_path__ + "img/ic-pin-drop-1.157da966.svg";